import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const mergeClassName = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
